import { render, staticRenderFns } from "./WeeklyCalendar.vue?vue&type=template&id=051a822c&scoped=true&"
import script from "./WeeklyCalendar.vue?vue&type=script&lang=js&"
export * from "./WeeklyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyCalendar.vue?vue&type=style&index=0&id=051a822c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a822c",
  null
  
)

export default component.exports